export default __webpack_public_path__ + "static/media/essentials-cover.8035aab8.jpg";